"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetContainer = void 0;
var utils_react_1 = require("@workspace/utils-react");
var react_1 = __importDefault(require("react"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function WidgetContainer(props) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        __webpack_public_path__ = props.widget.settings.remoteEntry;
    }
    catch (_a) { }
    return react_1.default.createElement(utils_react_1.WidgetProvider, { widget: props.widget }, props.children);
}
exports.WidgetContainer = WidgetContainer;
